import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    makeStyles,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormHelperText,
    IconButton,
} from '@material-ui/core';
import gray from '@material-ui/core/colors/grey';
import { v1 as uuid } from 'uuid';
import moment from 'moment';
import {
    InspectionList,
    ViolationCategory,
    LoggedInUser,
    Inspection,
    DropDownField,
    Application,
    LicensedInspectorReference,
} from '../../../../store/modules/application/types';
import InputTextComponent from '../../../../components/InputTextField';
import { Delete } from '@material-ui/icons';
import grey from '@material-ui/core/colors/grey';
import AutoCompleteSelect from '../../../../components/AutoCompleteSelect';
import { Skeleton } from '@material-ui/lab';

type AddNewViolationDialogProps = {
    categories: ViolationCategory[];
    setIsAddViolationModalOpen: Function;
    addViolation: Function;
    application: Application;
    inspectionList: InspectionList;
    eventInspection?: string;
    getCategoryList: Function;
    getInspectionList: Function;
    loggedInUser: LoggedInUser;
};

type newViolation = {
    key: string;
    typeError?: boolean;
    violationType: string;
    description: string;
    status: string;
};

const choices = {
    Found: {
        label: 'Found',
        value: 'Found',
    },
    Corrected: {
        label: 'Corrected',
        value: 'Corrected',
    },
};

function createNewRecord(): newViolation {
    return {
        key: uuid(),
        violationType: '',
        status: '',
        description: '',
    };
}

function validate(violation: newViolation, validatePartial: boolean) {
    if ((violation.violationType && violation.status) || (!violation.violationType && !violation.status)) {
        violation.typeError = false;
    } else if (validatePartial) {
        if (violation.violationType && !violation.status) {
        } else if (!violation.violationType && violation.status) {
            violation.typeError = true;
        }
    }
}

const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        display: 'flex',
        alignItems: 'baseline',
        color: gray[800],
        fontSize: 20,
        fontWeight: 600,
        marginLeft: theme.spacing(2),
    },
    selectInspections: {
        marginBottom: 30,
        marginTop: 20,
    },

    spacer: {
        flexGrow: 1,
    },
    dialogContent: {
        minHeight: 400,
    },
    tableRow: {
        verticalAlign: 'top',
    },
    tableFooterCell: {
        borderBottomWidth: 0,
    },
    label: {
        fontSize: 14,
        fontWeight: 500,
        color: gray[800],
        marginRight: theme.spacing(2),
        textAlign: 'right',
    },
    datePicker: {
        margin: 0,
    },
    datePickerContainer: {
        backgroundColor: 'white',
        borderRadius: 5,
        justifyContent: 'flex-start',
    },
    datePickerInput: {
        fontSize: 13,
        border: '1px solid rgb(0,0,0,0.23) !important',
        paddingTop: 7,
        paddingBottom: 3,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderRadius: 3,
        marginBottom: '5px',
        color: '#484848 !important',
        width: 150,
        '&:before': {
            borderBottomColor: 'white',
        },
        '&:after': {
            borderBottomColor: 'white',
        },
        '&:hover:before': {
            borderBottomColor: ['white', '!important'],
        },
    },
    selectInput: {
        fontSize: 13,
        border: '1px solid rgb(0,0,0,0.23) !important',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderRadius: 3,
        marginBottom: '5px',
        color: '#484848 !important',
        minWidth: 150,
        maxWidth: 150,
    },
    selectInput2: {
        fontSize: 13,
        border: '1px solid rgb(0,0,0,0.23) !important',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderRadius: 3,
        marginBottom: '5px',
        color: '#484848 !important',
        minWidth: 245,
        maxWidth: 245,
    },
    textField: {
        fontSize: 14,
        fontWeight: 450,
        color: gray[600],
        lineHeight: '21px',
        wordWrap: 'break-word',
        width: '100%',
    },
    textFieldInput: {
        fontSize: 13,
        border: '1px solid rgb(0,0,0,0.23) !important',
        padding: 10,
        borderRadius: 3,
        marginBottom: '5px',
        color: '#484848 !important',
        width: '100%',
    },
    heading: {
        textTransform: 'uppercase',
        fontSize: 12,
        marginBottom: 5,
        textAlign: 'left',
        fontWeight: 500,
        color: grey[600],
        marginLeft: theme.spacing(2),
        letterSpacing: 0.83,
    },

    amountInput: {
        textAlign: 'right',
    },
    fullWidth: {
        width: '100%',
    },
    MuiOutlinedInput: {
        backgroundColor: 'white',
        border: '1px solid #ced4da',
        borderRadius: 5,
        '&:focus': {
            backgroundColor: 'white',
            border: '1px solid #ced4da',
        },
        '&:hover': {
            backgroundColor: ['white', '!important'],
            border: '1px solid #ced4da',
        },
    },
    deleteIcon: {
        opacity: 1,
    },

    cellContainer: {
        verticalAlign: 'middle',
    },
    autoCompleteInputRoot: {
        width: '75%',
    },
    autoCompleteRoot: {
        marginBottom: '5px',
    },
    autoCompleteInput: {
        padding: '2.5px 4px !important',
    },
    violationInput: {
        padding: '3.5px 4px !important',
    },
    statusInput: {
        padding: '3.5px 4px !important',
    },
    readOnlyField: {
        color: '#484848',
        lineHeight: '21px',
        wordWrap: 'break-word',
    },
}));

const AddNewViolationDialog: FunctionComponent<AddNewViolationDialogProps> = (props) => {
    const {
        setIsAddViolationModalOpen,
        categories,
        inspectionList,
        application,
        addViolation,
        eventInspection,
        getCategoryList,
        getInspectionList,
        loggedInUser,
    } = props;
    const [violations, setViolation] = useState<any[]>([createNewRecord(), createNewRecord()]);
    const [userList, setUserList] = useState<any[]>([{ id: '', name: '', license: { id: '' } }]);
    const [signedInUser, setSignedInUser] = useState<LoggedInUser>({ accountIdentifier: '', name: '' });
    const [issuedBy, setIssuedBy] = useState<DropDownField | LicensedInspectorReference | null>(null);
    const [thirdPartyInspector, setThirdPartyInspector] = useState<DropDownField | null>(null);
    const [inspection, setInspection] = useState<DropDownField | null>(null);
    const [inspectionDetail, setInspectionDetail] = useState<any>('');
    const [isDisableAddButton, setIsDisableAddButton] = useState<boolean>(false);
    const [disable, setDisable] = useState<boolean>(false);

    const getInspectorList = useCallback(
        (inspectionId: string) => {
            var inspectionDetail = inspectionList.find((item: Inspection) => item.id === inspectionId);
            const list: { id: string; name: string } = inspectionDetail?.inspector!;
            setUserList([list]);
        },
        [inspectionList],
    );

    useEffect(() => {
        let shouldDisabled = false;
        let totalRecords = 0;
        for (let index = 0; index < violations.length; index++) {
            const element = violations[index];
            if (
                (element?.status !== '' && element?.violationType === '') ||
                (element?.status === '' && element?.violationType !== '')
            ) {
                shouldDisabled = true;
            }
            if (element?.status === '' && element?.violationType === '') {
                totalRecords += 1;
            }
        }
        if (totalRecords === violations.length) {
            shouldDisabled = true;
        }
        setDisable(shouldDisabled);
    }, [violations]);

    useEffect(() => {
        getInspectionList(application.id);

        getCategoryList({
            licenseTypeId: application?.type?.id,
        });
    }, [application, getCategoryList, getInspectionList]);

    useEffect(() => {
        if (eventInspection) {
            const selectedInspection = inspectionList.find(
                (inspection: Inspection) => inspection.id === eventInspection,
            );
            setInspection(
                selectedInspection?.id
                    ? {
                          label: `${selectedInspection.type.name} ${
                              !!selectedInspection?.inspectionDate
                                  ? moment(selectedInspection.inspectionDate).format('L')
                                  : ''
                          }`,
                          value: selectedInspection.id,
                      }
                    : null,
            );
            getInspectorList(eventInspection);
            setInspectionDetail(inspectionList.find((item: Inspection) => item.id === eventInspection));
        }
    }, [eventInspection, inspectionList, getInspectorList]);

    useEffect(() => {
        if (userList[0]?.license?.id) {
            setIssuedBy({
                label: userList[0]?.name,
                value: userList[0]?.license?.id,
            });
        } else {
            setIssuedBy({
                label: userList[0]?.name,
                value: userList[0]?.id,
            });
        }
    }, [userList, setIssuedBy]);

    useEffect(() => {
        const list: { accountIdentifier: string; name: string } = loggedInUser;
        setSignedInUser(list);
        if (!eventInspection) {
            setIssuedBy({ label: loggedInUser?.name, value: loggedInUser?.accountIdentifier });
        }
    }, [eventInspection, loggedInUser]);

    const handleChangeInspection = (data: DropDownField | null) => {
        const selectedInspection = inspectionList.find((inspection: Inspection) => inspection.id === data?.value);
        setInspectionDetail(selectedInspection);
        setInspection(data);
        data && getInspectorList(data.value);
        if (!selectedInspection?.id) {
            setIssuedBy({ label: loggedInUser?.name, value: loggedInUser?.accountIdentifier });
        } else if (selectedInspection?.inspector?.license?.id) {
            setIssuedBy({
                label: selectedInspection?.inspector?.name,
                value: selectedInspection?.inspector?.license?.id,
            });
            setThirdPartyInspector({
                label: selectedInspection?.inspector?.name,
                value: selectedInspection?.inspector?.license?.id,
            });
        } else {
            setIssuedBy(
                selectedInspection?.inspector?.id
                    ? {
                          label: selectedInspection?.inspector?.name,
                          value: selectedInspection?.inspector?.id,
                      }
                    : null,
                // TODO: Need to cater this for licensedInspector as well
            );
        }
    };

    const handleChangeIssuedBy = (data: DropDownField | LicensedInspectorReference | null) => {
        setIssuedBy(data);
    };

    const classes = useStyles();

    const updateViolation = (
        key: string,
        property: 'violationType' | 'status' | 'description',
        value: string | null,
    ) => {
        const updateViolation = [...violations];
        const violation = updateViolation.find((violation) => violation.key === key);
        if (violation) {
            // Check if removing value from a property that currently has a value.
            const valueRemoved: boolean = !!violation[property] && !value;
            violation[property] = value;

            validate(violation, valueRemoved);

            if (
                updateViolation[updateViolation.length - 1].violationType &&
                updateViolation[updateViolation.length - 1].status
            ) {
                // Add new blank entry if everything is filled out.
                updateViolation.push(createNewRecord());
            }

            setViolation(updateViolation);
        }
    };

    const handleAddViolationChange = () => {
        let issuedByUser = {};

        if (!inspection) {
            issuedByUser = {
                id: signedInUser.accountIdentifier || '',
                name: signedInUser.name || '',
            };
        } else if (thirdPartyInspector) {
            issuedByUser = {
                name: thirdPartyInspector?.label,
                license: {
                    id: thirdPartyInspector?.value,
                },
            };
        } else {
            issuedByUser = {
                id: userList[0]?.id || '',
                name: userList[0]?.name || '',
            };
        }

        const newViolationArray = violations

            .filter((element) => element.violationType)
            .map((element) => {
                const violationType = categories.find((category) => category.id === element.violationType);

                return {
                    category: { id: violationType?.id, name: violationType?.name },
                    description: element.description,
                    status: element.status,
                    issuedBy: issuedByUser,
                    license: {
                        id: application?.id,
                        licenseNumber: application?.licenseNumber,
                        type: application?.type,
                    },
                    inspection: inspectionDetail
                        ? {
                              id: inspectionDetail?.id,
                              inspectionDate: inspectionDetail?.inspectionDate,
                              type: inspectionDetail?.type,
                          }
                        : undefined,
                };
            });

        addViolation(newViolationArray);
        setIsDisableAddButton(true);
        setIsAddViolationModalOpen(false);
    };

    // Delete a violation from uploading queue

    const removeViolation = (index: number) => {
        const filteredViolationList = violations.filter((violation) => {
            return index !== violation.key;
        });

        setViolation(filteredViolationList);
    };
    const sortedList = (a: Inspection, b: Inspection) => {
        const date1 = new Date(b.inspectionDate!).valueOf();
        const date2 = new Date(a.inspectionDate!).valueOf();
        return date1 - date2;
    };

    const getInspectors = () => {
        let inspectors: DropDownField[] = [];
        if (userList && userList.length) {
            if (userList[0]?.id) {
                inspectors = userList?.map((user) => ({
                    label: user?.name,
                    value: user?.id,
                }));
            } else if (userList[0]?.license?.id) {
                inspectors = userList?.map((user) => ({
                    label: user?.name,
                    value: user?.license?.id,
                }));
            } else {
                inspectors = [
                    {
                        label: signedInUser?.name,
                        value: signedInUser?.accountIdentifier,
                    },
                ];
            }
        }
        return inspectors;
    };
    const Loader = <Skeleton variant="text" width="100%" />;
    return (
        <>
            <DialogTitle className={classes.dialogTitle} disableTypography>
                <Typography variant="h6">Add Violation</Typography>
                <div className={classes.spacer} />
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography className={classes.heading}>Select Inspection</Typography>
                    </Grid>
                    <Grid item container className={classes.selectInspections} xs={6} spacing={1} alignItems="baseline">
                        <Grid item xs={3}>
                            <Typography className={classes.label}>Inspection</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            {!!eventInspection ? (
                                <>
                                    {inspection?.label ? (
                                        <Typography variant="body2" className={classes.readOnlyField}>
                                            {inspection?.label}
                                        </Typography>
                                    ) : (
                                        Loader
                                    )}
                                </>
                            ) : (
                                <AutoCompleteSelect
                                    data={inspectionList
                                        .sort((a: Inspection, b: Inspection) => {
                                            return sortedList(a, b);
                                        })
                                        .map((inspection: Inspection) => ({
                                            label: `${inspection.type.name} ${
                                                inspection.inspectionDate
                                                    ? moment(inspection.inspectionDate).format('L')
                                                    : ''
                                            }`,
                                            value: inspection.id,
                                        }))}
                                    value={inspection}
                                    onChange={handleChangeInspection}
                                    inputSize={'small'}
                                    variant={'outlined'}
                                    ariaLabel="Inspection"
                                    disableClearable={false}
                                    classes={{
                                        input: classes.autoCompleteInput,
                                        inputRoot: classes.autoCompleteInputRoot,
                                    }}
                                />
                            )}
                        </Grid>
                        <Grid item xs={3}>
                            <Typography className={classes.label}>Issued By</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <AutoCompleteSelect
                                data={getInspectors()}
                                value={issuedBy}
                                onChange={handleChangeIssuedBy}
                                inputSize={'small'}
                                variant={'outlined'}
                                ariaLabel="Issued By"
                                disableClearable={true}
                                classes={{
                                    input: classes.autoCompleteInput,
                                    inputRoot: classes.autoCompleteInputRoot,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.heading}>Enter Violations</Typography>
                    </Grid>
                </Grid>

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell width="25%">Violation Type</TableCell>
                                <TableCell width="25%">Status</TableCell>
                                <TableCell align="left" size="small" width="40%">
                                    Description
                                </TableCell>
                                <TableCell align="left" size="small"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {violations.map((violation, index) => (
                                <TableRow key={violation.key} className={classes.tableRow}>
                                    <TableCell className={classes.cellContainer}>
                                        <AutoCompleteSelect
                                            data={categories.map((category: ViolationCategory) => ({
                                                label: category.name,
                                                value: category.id,
                                            }))}
                                            onChange={(data: DropDownField | null) => {
                                                const value = data !== null ? data.value : null;
                                                updateViolation(violation.key, 'violationType', value);
                                            }}
                                            inputSize={'small'}
                                            variant={'outlined'}
                                            ariaLabel="Violation Type"
                                            classes={{
                                                input: classes.violationInput,
                                                root: classes.autoCompleteRoot,
                                            }}
                                        />
                                        {violation.typeError && (
                                            <FormHelperText error>Violation Type is required</FormHelperText>
                                        )}
                                    </TableCell>

                                    <TableCell className={classes.cellContainer}>
                                        <AutoCompleteSelect
                                            data={Object.entries(choices).map((entry) => ({
                                                label: entry[1].label,
                                                value: entry[0],
                                            }))}
                                            onChange={(data: DropDownField | null) => {
                                                const value = data !== null ? data.value : null;
                                                updateViolation(violation.key, 'status', value);
                                            }}
                                            inputSize={'small'}
                                            variant={'outlined'}
                                            ariaLabel="Status"
                                            classes={{
                                                input: classes.statusInput,
                                                root: classes.autoCompleteRoot,
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.cellContainer}>
                                        <InputTextComponent
                                            id={`description-${violation.key}`}
                                            disabled={false}
                                            size="small"
                                            fontSize="13"
                                            className={classes.textField}
                                            inputProps={classes.textFieldInput}
                                            onChange={(description: string) =>
                                                updateViolation(violation.key, 'description', description)
                                            }
                                            value={violation.description}
                                        />
                                    </TableCell>

                                    {index < violations.length - 1 && (
                                        <TableCell className={classes.cellContainer}>
                                            <IconButton
                                                onClick={() => removeViolation(violation.key)}
                                                className={classes.deleteIcon}
                                            >
                                                <Delete />
                                            </IconButton>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button
                    disableElevation
                    onClick={() => {
                        setIsAddViolationModalOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    disableElevation
                    disabled={disable || !!isDisableAddButton}
                    color="primary"
                    onClick={handleAddViolationChange}
                >
                    Add
                </Button>
            </DialogActions>
        </>
    );
};

export default AddNewViolationDialog;
